var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIconSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.74194 18.6295V17.5879C1.74194 15.6543 2.51008 13.7999 3.87736 12.4326C5.24465 11.0653 7.09908 10.2972 9.03271 10.2972V10.2972C10.9663 10.2972 12.8208 11.0653 14.1881 12.4326C15.5554 13.7999 16.3235 15.6543 16.3235 17.5879V18.6295H1.74194ZM9.03271 10.2972C10.1376 10.2972 11.1973 9.85822 11.9786 9.07692C12.7599 8.29561 13.1989 7.23593 13.1989 6.131C13.1989 5.02607 12.7599 3.96639 11.9786 3.18508C11.1973 2.40378 10.1376 1.96484 9.03271 1.96484C7.92778 1.96484 6.8681 2.40378 6.0868 3.18508C5.30549 3.96639 4.86656 5.02607 4.86656 6.131C4.86656 7.23593 5.30549 8.29561 6.0868 9.07692C6.8681 9.85822 7.92778 10.2972 9.03271 10.2972V10.2972Z",
    stroke: "black",
    strokeWidth: 1.56231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIconSidebar);
export default __webpack_public_path__ + "static/media/profile-icon-sidebar.3c86e53f428352761e0dd1a14dd387ad.svg";
export { ForwardRef as ReactComponent };